import axios from 'axios';
import {APP} from '../../constants'

axios.defaults.baseURL = APP.API_URL;

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Accept-Language'] = APP.locale;

axios.interceptors.request.use(async (config) => {
    const tokenKey = 'Token'
    const url = config.url

    if(url.includes('jwplatform') || url.includes('viacep.com.br')){
        return config;
    }

    if (url === 'v1/users/token') {
        sessionStorage.removeItem(tokenKey)
        // never add token
        return config
    }

    const token = sessionStorage.getItem(tokenKey)

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

export function ApiService(options = {}) {
    return axios.request({
        method: 'get',
        ...options
    });
}

export function ErrorExtract(error) {
    let res = error.response;
    if (!res) {
        return {
            code: 404,
            message: 'Verifique a sua conexão com a internet.'
        };
    }
    return res.data.data;
}
